import styled from "styled-components";

export const WalletModalStyles = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  direction: rtl;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 1000;
  font-family: "IRANYekanMobileFN";
`;

export const ModalWrapper = styled.div`
  height: auto;
  width: 528px;
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 24px 24px;
  background: var(--bg-white);
  border-radius: 12px;
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 528px) {
    width: 360px;
  }
`;

export const ImgContainer = styled.div`
  width: 250px;
  height: 140px;
  margin-bottom: 24px;
  & img {
    width: 100%;
    height: auto;
    display: block;
  }
`;
export const TransactionMassage = styled.div`
  margin-bottom: 24px;
  & h2 {
    font-weight: 500;
    font-size: 16px;
    color: #27548c;
  }
`;
export const InfoContainer = styled.section`
  width: 100%;
  & > div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    color: #5276a3;
    font-size: 14px;
    font-weight: 500;
    border-bottom: 1px solid #e9ebf8;
    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      padding-bottom: 0;
      border: none;
    }
    & > div:last-child {
      font-weight: 400;
    }
  }
`;

export const Button = styled.div`
  border: none;
  outline: none;
  width: 140px;
  height: 40px;
  margin-top: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #6caeff;
  border-radius: 8px;
  color: #f4f7fc;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  align-items: center;
  justify-content: center;
  & div:last-child {
    background-color: #6caeff;
    border: 2px solid #6caeff;
    color: #f4f7fc;
    margin-left: 8px;
  }
  & div:first-child {
    margin-right: 8px;
  }
`;
